/**
 * Смена намерения при видео-референсе Seedance 2.5 («Переделать видео» | «Новое по
 * референсу») — ОДНА логика на все места, где переключатель живёт (пилюли десктопа,
 * шторка телефона), как у utils/seedanceMode.
 *
 * «edit» запирает длительность на длине референса: пилюля, цена и запрос должны
 * показать одно число ещё до запуска — поэтому при переключении настройка
 * длительности сразу подтягивается к референсу. «new» замок снимает, длительность
 * остаётся той, что стояла (юзер выбирает сам).
 */
import type { Model } from '../../../data/models'
import type { GenerateSettings } from '../hooks/useGenerateSettings'
import { durationFollowsReference, type VideoIntent, videoIntentOf } from './referenceLimits'

export interface VideoIntentSwitchApi {
	model: Model | null | undefined
	settings: Pick<GenerateSettings, 'seedanceMode' | 'videoIntent' | 'duration'>
	referenceVideos: { duration?: number; url?: string; cardRef?: boolean }[]
	updateSetting: <K extends 'videoIntent' | 'duration'>(key: K, value: GenerateSettings[K]) => void
}

export function switchVideoIntent(api: VideoIntentSwitchApi, intent: VideoIntent): void {
	if (videoIntentOf(api.settings) === intent) return
	api.updateSetting('videoIntent', intent)
	if (intent !== 'edit') return
	const follow = durationFollowsReference(api.model, { ...api.settings, videoIntent: 'edit' }, api.referenceVideos)
	if (follow != null && api.settings.duration !== String(follow)) api.updateSetting('duration', String(follow))
}
